import { PageMeta } from '../insights/insights.models';

export const REPORTS_BUILDER_PAGE_META: Record<string, PageMeta> = {
	'^/reports-builder': {
		pagegroup: 'reports-builder',
		pagename: 'report'
	}
};
